module.exports = __webpack_public_path__ + "img/list_1.5f9fa91a.jpg";